/**
 * Monitor Finances Lesson
 * Skill Area: Operations
 * Track budgets before issues become crises
 */

import type { LessonDefinition } from '../types';
import { MONITOR_FINANCES_AI_PROMPT } from '../prompts/monitor-finances.prompt';

export const monitorFinances: LessonDefinition = {
  id: 'monitor-finances',
  title: 'Monitor Finances',
  displayTitle: 'Track Budgets Before Issues Become Crises',
  subTitle: 'Track budgets in real-time',
  persona: 'Lyra',
  skillArea: 'Operations',
  topicId: 'programs-projects',
  topicTitle: 'Programs & Projects',
  topicDescription: 'Analyze options, build plans, monitor finances, and balance team workload.',
  format: 'tool_lab',
  difficulty: 'Intermediate',
  estimatedMinutes: 7,
  tags: ['budgets', 'monitoring', 'finance'],
  dailyEligible: true,
  releasedAt: '2025-01-22T00:00:00.000Z',
  route: '/micro/monitor-finances',
  storyBeat: 'Catch budget issues early before they become crises.',
  introPrompt: "Budget surprises destroy nonprofits. By the time you realize you've overspent, it's too late to course-correct. But you don't need complex spreadsheets—you need a simple system. Let's build one.",
  steps: [
    "Identify the budget line that keeps you up at night",
    "Answer 4 questions to build your monitoring dashboard",
    "Get your Financial Health Check + reusable prompt",
    "Practice on a second budget area to prove mastery"
  ],
  promptGuidance: 'Choose a budget concern below or describe your own.',
  aiPrompt: MONITOR_FINANCES_AI_PROMPT,
  inputPlaceholder: "e.g., Grant spend-down, Event budget, Cash runway...",
  quickPrompts: [
    'Grant spend-down tracking',
    'Event budget monitoring',
    'Cash runway forecast',
    'Program expense variances'
  ]
};
